import { HistoryEventListItem } from 'Components/_NewElements/HistoryEvents';
import * as React from 'react';
import { capitalize } from 'Utility/string';

const AdverseEventListItem = ({ adverseEvent }: IAdverseEventItemProps): React.JSX.Element => {
  return (
    <>
      {adverseEvent.adverseEffects && (
        <HistoryEventListItem
          title={'medication.adverseEffects'}
          value={
            <>
              {adverseEvent.adverseEffects.map((a, i) =>
                a.eventName === 'Muu haittavaikutus' ? (
                  <React.Fragment key={a.eventName + i}>
                    <span>{`${capitalize(a.eventName)} (${adverseEvent.otherAdverseEffect ?? ''})`}</span>
                    {i !== (adverseEvent.adverseEffects?.length as number) - 1 && ', '}
                  </React.Fragment>
                ) : (
                  <React.Fragment key={`${a.eventName ?? ''}${i}`}>
                    <span>{a.eventName && capitalize(a.eventName)}</span>
                    {i !== (adverseEvent.adverseEffects?.length as number) - 1 && ', '}
                  </React.Fragment>
                ),
              )}
            </>
          }
        />
      )}
      {adverseEvent.eventDetails && (
        <HistoryEventListItem title={'medication.eventDetails'} value={adverseEvent.eventDetails} />
      )}
    </>
  );
};

interface IAdverseEventItemProps {
  adverseEvent: IMedicationAdverseEvent;
  startEdit: StartEdit;
}

export default AdverseEventListItem;
